import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ZkInputModule } from '@zenklub/ng-ui';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { ZkCurrencyInput } from './currency-input.component';

@NgModule({
	imports: [FormsModule, CommonModule, ZkInputModule, CurrencyMaskModule],
	exports: [ZkCurrencyInput],
	declarations: [ZkCurrencyInput],
	providers: [],
})
export class ZkCurrencyInputModule {}
